<template>
  <!-- 添加或修改菜单对话框 -->
  <el-dialog :title="!form.deptId ? '新增': '修改'"
             :visible.sync="visible" append-to-body >
    <div class="scrollable-content">
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-row>
        <el-col>
          <el-form-item label="上级部门">
            <treeselect v-model="form.parentId"
                        :options="deptOptions"
                        :normalizer="normalizer"
                        :show-count="true"
                        placeholder="选择上级菜单"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="部门名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入菜单名称"/>
      </el-form-item>
      <el-form-item label="部门编码" prop="orgCode">
        <el-input v-model="form.orgCode" placeholder="请输入部门编码"/>
      </el-form-item>
      <el-form-item label="部门负责人" prop="manager">
        <el-input v-model="form.manager" placeholder="请输入部门负责人"/>
      </el-form-item>
      <el-form-item label="负责人电话" prop="managerMobile">
        <el-input v-model="form.managerMobile" placeholder="请输入部门负责人电话"/>
      </el-form-item>
      <el-form-item label="渠道负责人" prop="channleManager">
        <el-input v-model="form.channleManager" placeholder="请输入渠道负责人"/>
      </el-form-item>
      <el-form-item label="负责人电话" prop="channleManagerMobile">
        <el-input v-model="form.channleManagerMobile" placeholder="请输入渠道负责人电话"/>
      </el-form-item>
      <el-form-item label="技术负责人" prop="techManager">
        <el-input v-model="form.techManager" placeholder="请输入技术负责人"/>
      </el-form-item>
      <el-form-item label="负责人电话" prop="techManagerMobile">
        <el-input v-model="form.techManagerMobile" placeholder="请输入技术负责人电话"/>
      </el-form-item>
      <el-form-item label="排序" prop="sortOrder">
        <el-input-number v-model="form.sortOrder" controls-position="right" :min="0"/>
      </el-form-item>
        <el-form-item  label="服务地区">
          <template>
            <el-cascader :props="areaProps" v-model="form.userProvince" :clearable="true" style="width: 9vw;"
                         @change="handleChange" ref="cascaderAddr">
            </el-cascader>
            <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData" style="margin: 5px 5px;">
              <i class="el-icon-plus"></i>
              添加服务区域
            </el-button>
            <el-button style="margin: 5px 5px;"
                       type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
              <i class="el-icon-delete"></i>
              批量删除
            </el-button>
          </template>
        </el-form-item>

      <el-form-item>
        <vxe-table ref="filterTable" :data="areaData" class="table_item pic_item"

                   :stripe="true"
                   :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-config="{height: 30,isHover: true,padding: 0,}"
                   :row-style="{ fontSize: '12px',  }"
                   show-overflow
                   height="260" :column-config="{ resizable: true }"
                   @checkbox-all="areaSelectAll"
                   @checkbox-change="areaSelect"
        >
          <vxe-column type="checkbox" width="40"></vxe-column>
          <vxe-column field="areaNamePath" title="省市区地址" width="330">
          </vxe-column>

          <vxe-column title="操作" width="60">
            <template slot-scope="scope">
              <div @click="handleDelete(scope.row.id)">
                <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </el-form-item>

    </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmit">确 定</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {addObj, fetchTree, getObj, putObj,getDeptAreas} from '@/api/admin/dept'
import Treeselect from "@riophae/vue-treeselect"
import TableForm from './'
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
import request from "@/router/axios";

export default {
  name: "DeptForm",
  components: {Treeselect, TableForm},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 菜单树选项
      deptOptions: [],
      // 是否显示弹出层
      visible: false,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaData:[],
      getAreaDataUrl: '/basic/basArea/getList',
      getAreaPathDataUrl: '/basic/basArea/getAreaPathList',
      area: {
        temp: {},
        checkedArray: []
      },
      form: {
        orgCode:'',
        name: undefined,
        sortOrder: 999,
        manager:undefined,
        managerMobile:undefined,
        techManager:undefined,
        techManagerMobile:undefined,
        channleManager:undefined,
        channleManagerMobile:undefined
      },
      // 表单校验
      rules: {
        name: [
          {required: true, message: "部门名称不能为空", trigger: "blur"}
        ],
        orgCode: [
          {required: true, message: "部门编码不能为空", trigger: "blur"}
        ],
        sortOrder: [
          {required: true, message: "部门顺序不能为空", trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    init(isEdit, id) {
      if (id !== null) {
        this.form.parentId = id;
      }
      this.visible = true
      this.getTreeselect();
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (isEdit) {
          getObj(id).then(response => {
            this.form = response.data.data
          })
          getDeptAreas(id).then(response =>{
            this.areaData = response.data.data
          })
        } else {
          this.form.deptId = undefined
          this.areaData = []
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.form.parentId === undefined) {
            this.form.parentId = 0
          }
          console.log(this.areaData,"this.areaData")
          let areaIdList = this.areaData.map(item => {
            return{areaId:item.id,areaName:item.areaName,areaNamePath:item.areaNamePath}}
          )
          this.form.areaDTOList = areaIdList;
          if (this.form.deptId) {
            putObj(this.form).then(data => {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('refreshDataList')
            });
          } else {
            addObj(this.form).then(data => {
              this.$message.success('添加成功')
              this.visible = false
              this.$emit('refreshDataList')
            })
          }
        }
      })
    },
    /** 查询菜单下拉树结构 */
    getTreeselect() {
      fetchTree().then(response => {
        this.deptOptions = []
        const dept = {id: 0, name: '根部门', children: response.data.data};
        this.deptOptions.push(dept)
      });
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }

      return {
        id: node.id,
        label: node.name,
        children: node.children
      }
    },
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: this.getAreaDataUrl,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.area.temp = {
        id: areaNode[0].value,
        level: areaNode[0].level
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },

    // 添加地区列表
    addAreaData() {
      if (this.area.temp.level < 2) {
        this.$message.warning('请至少选择到省级地址')
      } else {
        if (this.area.temp.level === 4 || this.area.temp.level === 3 || this.area.temp.level === 2 ) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaName:item.areaName,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaName:item.areaName,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    // 单个地区删除
    handleDelete(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.areaData = this.areaData.filter(item => item.id !== id)
      })
    },

    // 批量删除地区
    handleDeleteList() {
      console.log(this.area.checkedArray)
      if (this.area.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.area.checkedArray.forEach(item => {
            this.areaData = this.areaData.filter(item1 => item1.id !== item.id)
          })
          this.area.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.area.checkedArray.push(data.row)
      } else {
        this.area.checkedArray = this.area.checkedArray.filter(item => item.id !== data.row.id)
      }
    },

    // 地址全选
    areaSelectAll(selection) {
      this.area.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area.checkedArray.push(item)
      })
      console.log(this.area.checkedArray.length)
    },
  }
};
</script>

<style scoped>
.scrollable-content {
  height: 100%; /* Make the div take up the full height of the dialog */
  overflow-y: auto; /* Add a vertical scrollbar when required */
}
::v-deep .el-dialog__body {
    height: 400px;
    display: inline-block;
}
</style>
